import React, { useState } from "react";
import "../assets/css/style.css";
import "../assets/css/setup.css";

import Projects from "../components/projects/projectPage";

const Project = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="main">
      <Projects />
    </div>
  );
};

export default Project;
